import logsModuleCreators from '../../utils/store';
import LogRepository from '../../repositories/Admin/FastCash/LogRepository';

const { createLoadActionStoreModule } = logsModuleCreators;

export const { slice, selectors, useActions } = createLoadActionStoreModule({
  slicePath: ['admin', 'logs'],
  repositoryAction: LogRepository.load,
  responseKey: 'logs',
});

export default slice.reducer;
